import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import {
  WIFI_THERMOSTATS_REQUEST,
} from '../types/wifiThermostats';
import { loadWifiThermostats } from '../../services/wifiThermostats';
import {
  wifiThermostatsRequest,
  wifiThermostatsRequestFailed,
  wifiThermostatsRequestSuccess,
} from '../actions/wifiThermostats';

function* loadWifiThermostatsSaga(action: ReturnType<typeof wifiThermostatsRequest>) {
  try {
    const { data } = yield call(loadWifiThermostats, action.payload);

    yield put(wifiThermostatsRequestSuccess(data));
  } catch (err) {
    yield put(wifiThermostatsRequestFailed({ message: (err as Error).message }));
  }
}

export default all([
  takeLatest<any>(WIFI_THERMOSTATS_REQUEST, loadWifiThermostatsSaga),
]);
